export default __webpack_public_path__ + "static/media/openai-gpt3.png.webp";